import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/dect-handset.vue
var o = {
	name: "DtIconDectHandset",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--dect-handset"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Dect Handset",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M3 2A1.5 1.5 0 0 1 4.5.5h3A1.5 1.5 0 0 1 9 2v8a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 3 10V2Zm5 3V2a.5.5 0 0 0-.5-.5h-3A.5.5 0 0 0 4 2v3h4ZM4 6h4v4a.5.5 0 0 1-.5.5h-3A.5.5 0 0 1 4 10V6Zm.793-3.5a.5.5 0 0 1 .5-.5h1.414a.5.5 0 0 1 0 1H5.293a.5.5 0 0 1-.5-.5Zm-.168 5a.5.5 0 0 1 .5-.5h.004a.5.5 0 0 1 .001 1h-.004a.5.5 0 0 1-.501-.5Zm1.75 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5ZM4.625 9a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Zm1.75 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1h-.005a.5.5 0 0 1-.5-.5Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=dect-handset.js.map